export class Business {
  accountId: string;
  active: boolean;
  businessName: string;
  id: string;

  constructor(json: any) {
    this.accountId = json.accountId;
    this.active = json.active;
    this.businessName = json.businessName;
    this.id = json.id || json._id;
  }
}
